import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { authApi } from '../lib/api';
import { LoadingScreen } from './ui/Spinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = false,
}) => {
  const location = useLocation();
  const { isAuthenticated, user, accessToken, setUser, setLoading, logout, isLoading } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      if (accessToken && !user) {
        try {
          const userData = await authApi.getMe();
          setUser(userData);
        } catch (error) {
          logout();
        }
      }
      setIsChecking(false);
      setLoading(false);
    };

    checkAuth();
  }, [accessToken, user, setUser, setLoading, logout]);

  if (isChecking || isLoading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  if (!isAuthenticated || !accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requireAdmin && user?.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
